import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getSubjectLoadDataService } from "../../../services/subjectService";
import Loader from "../../../components/Loader";
import { DynamicForm } from "../DynamicForm/DynamicForm";

const AddSubject = () => {
  const [load, setLoad] = useState(false);
  const [questionData, setQuestionData] = useState([]);
  const [allQuestionsData, setAllQuestionsData] = useState(null);
  const [jsonStrings, setJsonStrings] = useState([]);
  const [pageName, setPageName] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [languageData, setLanguageData] = useState(null);
  const access_token = localStorage?.getItem("access_token");
  const siteId = useLocation()?.state?.siteId;

  const navigate = useNavigate();

  useEffect(() => {
    if (access_token && siteId) {
      getSubjectLoadData(access_token, siteId);
    }
  }, [siteId, access_token]);

  useEffect(() => {
    if (questionData && questionData?.length > 0) {
      let tempArray = [];
      questionData?.forEach((item) => {
        let obj = JSON.parse(item?.json);
        obj.answer_id = item?.answers[0]?.questionId;
        const updatedJsonString = JSON.stringify(obj, null);
        tempArray.push(updatedJsonString);
      });

      setJsonStrings(tempArray);
    }
  }, [questionData]);

  const getSubjectLoadData = async (access_token, siteId) => {
    setLoad(true);
    const data = {
      patientId: null,
      siteId: siteId,
      visitId: 0,
      pageId: null,
    };
    try {
      const res = await getSubjectLoadDataService(access_token, data);
      if (res?.data?.status == 200) {
        setLoad(false);
        setQuestionData(
          res?.data?.result?.patientVisitData?.questionnaire?.questions,
        );
        setAllQuestionsData(res?.data?.result);
        setPageName(
          res?.data?.result?.patientVisitData?.questionnaire?.internalName,
        );
      }
    } catch (err) {
      console.log(err);
      setLoad(false);
      if (err?.status == 404) {
        navigate("unAuthorized");
      }
    }
  };

  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div className={showConfirm ? "" : "content-body"}>
          {showConfirm ? null : (
            <>
              <p className="bread-crumbs-link-container">
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) => {
                    navigate("/");
                  }}
                >
                  Home
                </button>{" "}
                |{" "}
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) => {
                    navigate("/subject");
                  }}
                >
                  Subject Management
                </button>{" "}
                |{" "}
                <button className="bread-crumbs-btn" to="/add-subject">
                  Add Subject
                </button>
                -{" "}
                <b style={{ color: "gray" }}>
                  {localStorage?.getItem("studyName")}
                </b>
              </p>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "-30px",
                }}
              >
                <p className="page-heading" style={{ fontSize: "24px" }}>
                  {pageName}
                </p>
              </div>
            </>
          )}

          {jsonStrings?.length > 0 ? (
            <DynamicForm
              fieldJsonList={jsonStrings}
              allQuestionsData={allQuestionsData}
              setLoad={setLoad}
              setShowConfirm={setShowConfirm}
              showConfirm={showConfirm}
              responseData={responseData}
              setResponseData={setResponseData}
              pageName={pageName}
              languageData={languageData}
              setLanguageData={setLanguageData}
            />
          ) : (
            <h3
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "40px",
              }}
            >
              {" "}
              No questions available
            </h3>
          )}
        </div>
      )}
    </>
  );
};

export default AddSubject;
